import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'columns-1', 'Columns1', [["path",{"d":"M5 4a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v16a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1l0 -16"}]]);